import { Component, Input, OnChanges } from '@angular/core';
import { AlertaService } from '../../../services/alerta.service';
import { UserDataDto } from '../../../dto/auth/user-data.dto';
import { Constants } from '../../../constants/constants';

@Component({
  selector: 'app-visualizar-alertas-expediente',
  templateUrl: './visualizar-alertas-expediente.component.html',
  styleUrl: './visualizar-alertas-expediente.component.scss',
})
export class VisualizarAlertasExpedienteComponent implements OnChanges {
  cambios = 0;
  actualizaciones = 0;
  @Input() expedienteId?: number;
  userData: UserDataDto = {};

  constructor(private alertaService: AlertaService) {
    this.userData = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
  }

  ngOnChanges() {
    this.contarAlertas();
  }

  contarAlertas() {
    this.alertaService
      .contarPorFiltro({
        expediente: this.expedienteId,
        leido: false,
        tipoAlerta: 2,
        usuario: this.userData.idUsuario,
      })
      .subscribe(cantidad => {
        this.cambios = cantidad;
        this.actualizaciones = cantidad;
      });
  }

  marcarLeido() {
    this.alertaService
      .marcarLeidoPorFiltro({
        expediente: this.expedienteId,
        tipoAlerta: 2,
        usuario: this.userData.idUsuario,
      })
      .subscribe(() => {
        this.cambios = 0;
      });
  }
}
